import FileApi from "../../../api/modules/FIleApi";
import util from '../../../util'

const searchAvailableFiles = (_, payload) => {
  return FileApi.searchAvailableFiles(payload.context, payload.idClient, payload.process, payload);
};

const loadRecentFiles = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get('/files/recent/' + payload.idClient + '/' + payload.type, {headers}).then((response) => {
      commit('setFiles', {files: response.data.files})
      commit('setCountFiles', response.data.count)
      resolve(response.data)

    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar los archivos.')
      reject(error)
    });

  })

};

const setFiles = ({commit}, payload) => {
  commit('setFiles', {files: payload.files})
  commit('setCountFiles', payload.files.length)
};

const loadFilesInClient = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`/files/client/${payload.idClient}/inclient?${payload.params}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      util.showDialogError(payload.context, 'Ocurrió un error al cargar los archivos.')
      reject(error)
    });
  })
};

const searchPickupFiles = async ({commit}, payload) => {
  try {
    const {context, ...data} = payload;
    const response = await FileApi.searchPickupFiles(context, data);
    if (response && response.data && response.data.data) {
      return Object.assign({}, response, {data: response.data.data});
    }
    return response;
  } catch (error) {
    console.error("Error al buscar archivos para recojo:", error);
    throw error;
  }
};

const findFilesByBoxes = async ({commit}, payload) => {
  try {
    const {context, ...data} = payload;
    return await FileApi.findFilesByBoxes(context, data);
  } catch (error) {
    console.error("Error obteniendo archivos por cajas:", error);
    throw error;
  }
};

const loadAttachments = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`attachments/${payload.idFile}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });

  })

}

const downloadAttached = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()
    payload.context.axios.get(`/download/${payload.bucket}/${payload.name}/${payload.ext}`, {
      headers,
      responseType: 'blob'
    }).then((response) => {

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', payload.orgininalFileName);
      document.body.appendChild(link);
      link.click();

      resolve(response.data)

    }).catch(error => {

      const reader = new FileReader()

      // This fires after the blob has been read/loaded.
      reader.addEventListener('loadend', (e) => {
        const text = e.srcElement.result;
        const obj = JSON.parse(text)
        util.showDialogError(payload.context, obj.message)
      });
      reader.readAsText(error.response.data);

      reject(error)
    });

  })

};

const saveDigitalization = ({commit}, payload) => {

  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post(`digitalization`, payload.digitalization, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });

  })

}

const loadDigitalizations = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`/digitalization/client/${payload.idClient}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });

  })
}

const cancelDigitalization = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.delete(`/digitalization/${payload.id}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)
    });

  })
}

const saveConsultasFile = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.post(`inquiries`, payload.inquiries, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });

  })
}

const loadInquiries = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.get(`/inquiries/client/${payload.idClient}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)

    });

  })
}

const cancelInquiries = ({commit}, payload) => {
  return new Promise((resolve, reject) => {
    const headers = util.getAuthHeader()

    payload.context.axios.delete(`/inquiries/${payload.id}`, {headers}).then((response) => {
      resolve(response.data)
    }).catch(error => {
      if (error.response) {
        util.showDialogError(payload.context, error.response.data.message)
        reject(error.response)
      } else reject(error)
    });
  })
}

export default {
  searchAvailableFiles,
  loadRecentFiles,
  setFiles,
  loadFilesInClient,
  searchPickupFiles,
  findFilesByBoxes,
  loadAttachments,
  downloadAttached,
  saveDigitalization,
  loadDigitalizations,
  cancelDigitalization,
  saveConsultasFile,
  loadInquiries,
  cancelInquiries,
};



// WEBPACK FOOTER //
// ./src/store/modules/files/actions.js